import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { Tabs } from 'antd';
import history from '../modules/history';
import {
  UserProfileContainer,
  UserPlanContainer,
  UserPaymentContainer,
  UserBillingHistoryContainer,
} from '../containers/UserContainer';

const { TabPane } = Tabs;

export class User extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  onChange = (activeKey) => {
    history.push(activeKey);
  }

  // <Route path="/user/profile" foo="bar" component={UserProfileContainer} />
  // <Route
  //   {...commonProps}
  //   path="/user/profile"
  //   render={(props) => <UserProfileContainer {...props} />}
  // />
  render() {
    // const commonProps = {
    //   foo: 'bar',
    // };
    return (
      <div className="app__user">
        <Switch>
          <Tabs
            type="card"
            activeKey={this.props.location.pathname}
            onChange={this.onChange}
          >

            <TabPane tab="Profile" key="/user/profile">
              <Route path="/user/profile" component={UserProfileContainer} />
            </TabPane>

            <TabPane tab="Plan" key="/user/plan">
              <Route path="/user/plan" component={UserPlanContainer} />
            </TabPane>

            <TabPane tab="Payment" key="/user/payment">
              <Route path="/user/payment" component={UserPaymentContainer} />
            </TabPane>

            <TabPane tab="Billing History" key="/user/billing">
              <Route path="/user/billing" component={UserBillingHistoryContainer} />
            </TabPane>

          </Tabs>
        </Switch>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/presentation/User.jsx